import { EditorImageUpload } from 'components/Editors/components/EditorImageUpload';
import { JRCInputTextRaw } from 'components/Form/Input/JRCInputTextRaw/JRCInputTextRaw';
import { JRCIcon } from 'components/JRCIcon/JRCIcon';
import { JRCIconButton } from 'components/JRCIconButton/JRCIconButton';

import { jFileLittle, WidgetQuickSurveyContentArr } from 'jamespot-user-api';
import React, { FC, useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import styled from 'styled-components';
import { JRCWidgetQuickSurveyImage } from './JRCWidgetQuickSurveyImage';

const Row = styled.div`
    width: 100%;
    flex: 1;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    gap: 8px;
    cursor: pointer;
`;

const DnDIcon = styled(JRCIcon)`
    cursor: pointer;
`;

export const CSSRowLinkWrapper = styled.div<{ border?: boolean }>`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    border-bottom: ${(props) => (props.border ? `1px solid ${props.theme.color.grey1}` : 'none')};
    min-height: 24px;
    padding: 4px 8px;

    &:last-child {
        border-bottom: none;
    }
`;

type Item = {
    title: string;
    id?: number;
};

type JRCWidgetQuickSurveyWrapperItemProps = {
    token?: string;
    index: number;
    item: WidgetQuickSurveyContentArr;
    itemFile?: jFileLittle;
    length: number;
    inputRef: React.RefObject<HTMLInputElement>;
    setItems: (id: number, item: Item) => void;
    removeItem: (id: number) => void;
    handleRemoveImage: (idWidget: number) => void;
    handleAddImageWidget: (index: number, file: jFileLittle) => void;
    handleNewItem: () => void;
};

export const JRCWidgetQuickSurveyWrapperItem: FC<JRCWidgetQuickSurveyWrapperItemProps> = ({
    token,
    item,
    setItems,
    removeItem,
    handleAddImageWidget,
    handleRemoveImage,
    inputRef,
    length,
    index,
    handleNewItem,
}) => {
    const intl = useIntl();
    const [file, setFile] = useState<jFileLittle | undefined>(item.file ?? undefined);

    const onUploadSuccess = (file: jFileLittle) => {
        handleAddImageWidget(index, file);
        setFile(file);
    };

    const handleRemove = () => {
        handleRemoveImage(index);
        setFile(undefined);
    };

    useEffect(() => {
        if (item.file === undefined) {
            setFile(undefined);
        } else if (file === undefined && item.file) {
            setFile(item.file);
        }
    }, [item, file]);

    return (
        <div key={index}>
            <Row>
                <DnDIcon name="icon-reorder" color={'grey5'} size={14} />
                <JRCInputTextRaw
                    id={'title'}
                    required={true}
                    placeholder={intl.formatMessage({ id: 'FIELDS_Add_Option' })}
                    type="text"
                    value={item.title}
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                        const { value } = e.target;
                        setItems(index, { ...item, title: value });
                    }}
                    customRef={inputRef}
                    margin={'2px'}
                    width="100%"
                    onKeyDown={(e) => {
                        if (e.key === 'Enter') {
                            handleNewItem();
                        }
                    }}
                />

                {token && (
                    <EditorImageUpload token={token} initialFile={file} onUploadSuccess={onUploadSuccess}>
                        {(open) => {
                            return (
                                <>
                                    <JRCIconButton
                                        onClick={open}
                                        icon="icon-image"
                                        bg={'grey1'}
                                        bgHover={'grey2'}
                                        color={'grey5'}
                                        iconSize={14}
                                        title={intl.formatMessage({ id: 'BUTTON_Title_Add_Image' })}
                                    />
                                </>
                            );
                        }}
                    </EditorImageUpload>
                )}
                {length > 1 && (
                    <JRCIconButton
                        bg={'grey1'}
                        bgHover={'grey2'}
                        color={'grey5'}
                        iconSize={14}
                        onClick={() => removeItem(index)}
                        icon={'icon-close'}
                        title={intl.formatMessage({ id: 'BUTTON_Title_Remove_Item' })}
                    />
                )}
            </Row>
            {file && <JRCWidgetQuickSurveyImage file={file} margin={30} handleRemove={handleRemove} />}
        </div>
    );
};
